import JSHelp from './JSHelp';

export default { JSHelp };
